// @flow
export { default, DismissIconWrapper } from './Alert';
export type { Props } from './Alert';



// WEBPACK FOOTER //
// ../react-lib/src/components/notifications/Alert/index.js